module.exports = __webpack_public_path__ + "static/img/btn_fold@2x_on.44eb823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/btn_fold@2x_on.png
// module id = xGlT
// module chunks = 10